<template>
  <div class="background-container">
    <div class="background-image blur" ref="background"></div>
    <img hidden ref="image" alt="background image" :src="src"/>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BackGround',
  data: () => ({
    src: require('../assets/background.jpg'),
  }),
  mounted() {
    const image = this.$refs.image as HTMLImageElement
    const background = this.$refs.background as HTMLDivElement
    image.addEventListener('load', () => {
      setTimeout(() => {
        background.classList.remove('blur')
        background.style.backgroundImage = `url(${this.src})`
      }, 1000)
    })
    image.src = this.src
  },
})
</script>

<style scoped lang="scss">
.background-container {
  position: fixed;
  display: inline-block;
  overflow: hidden;
  width: 100vw;
  height: 100vh;
  top: 0;
  z-index: -1;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #414a4f;
    opacity: 0.75;
  }
}
.background-image {
  width: 100%;
  height: 100%;
  filter: blur(0px);
  transform: scale(1.1);
  transition: 1000ms filter linear;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url('data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEASABIAAD/2wBDAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/2wBDAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQH/wAARCAANABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAgKBwn/xAAkEAACAwEAAQMEAwAAAAAAAAADBAIFBgEHAAgSCRMUFRYXJv/EABYBAQEBAAAAAAAAAAAAAAAAAAMEBv/EACARAAICAgEFAQAAAAAAAAAAAAIDAQQFERIGBxMhMTL/2gAMAwEAAhEDEQA/AME9mPl72nefKSv/ALU8Rk8a5DYWJrpTV5Sqa1NBWXtRaMxV7dprZwbFZVuLITY/zbrMhldbXPSTFOFgo6e3yv02vEinNSW+2q+qPYtkzh8mhREqnkhfCBfnc21ujXVoUwzCweJp2jXFCQAwsV0RI9n+9k3dHrvCH8csdrrk8vXweI7lqXQ3NNnrq7uFFRraJ+rrrEC/7Oq6oPoIwj+IxAhwnX6InIxWzts75R3K1fsift/y8j5AZC8yRklim/luaE/XBudY4Q3bM1eNk67P3VwsknKIyLxEqN8N3rxePB9C5jc9DaMErKlWydNtO40Ab5LEV7FLyyu2muR2Ksv4gIACTE51GKzPbl2QcFuLGJgiPlQNmOshZrLEhlaxdXyCwFtYjmU2QSJERnLQIdRPeDyL7xfZVSaUlbRYyi1CS6SfJ3OmqcryzabmPpGed4kNyP2Bkl2ApsFiybvJnmEECjFE9TBZfxZzyDV81Ntr9IiawYN0CFR2uWSSVh8ODBGJkmZlL0nSmMfnQwIU0vtrhhzkPR6V/djp1DmJnBK2spEubsqRco1y5Sm4pUzve/EoF/eAwOom9fSGSkAmcy6NiM6FFHjHofzLa7WTGo9SxhnP0ikvv//Z');

  &.blur {
    filter: blur(50px);
  }
}
</style>
